import React from 'react'

import Script from 'next/script'

import { useUser } from 'hooks'

const ExposeUserScript = () => {
  const [user] = useUser()

  if (!user) {
    return null
  }

  return (
    <Script id="user-info">
      {`
      (function() {
        window.user = {
          email: "${user.email}",
          firstName: "${user.first_name}",
          lastName: "${user.last_name}",
          loginType: "${user.provider}",
          avatar: "${user.picture_url}",
        }
      })()
    `}
    </Script>
  )
}

export default ExposeUserScript
